import type { Theme } from '../../core/theme';
import { xAxisThemeParse } from './component/xAxis';
import { tooltipThemeParse } from './component/tooltip';
import { axisPointerThemeParse } from './component/axisPointer';
import { dataZoomThemeParse } from './component/datazoom';
import { colorThemeParse } from './component/color';
import { yAxisThemeParse } from './component/yAxis';
import { gridThemeParse } from './component/grid';
import { barThemeParse } from './series/bar';
import { progressBarThemeParse } from './series/progress';
import { lineThemeParse } from './series/line';
import { pieThemeParse } from './series/pie';
import { graphicParse } from './component/graphic';

export const ainvestAppLight = {
  name: 'ainvest-app-light' as const,
  parsers: [
    // component -------------------------------------------------------
    xAxisThemeParse,
    tooltipThemeParse,
    axisPointerThemeParse,
    dataZoomThemeParse,
    yAxisThemeParse,
    gridThemeParse,
    colorThemeParse,
    graphicParse,

    // series -------------------------------------------------------
    barThemeParse,
    progressBarThemeParse,
    lineThemeParse,
    pieThemeParse
  ]
} as Theme;

export const ainvestAppDark = {
  name: 'ainvest-app-dark' as const,
  parsers: [
    // component -------------------------------------------------------
    xAxisThemeParse,
    tooltipThemeParse,
    axisPointerThemeParse,
    dataZoomThemeParse,
    yAxisThemeParse,
    gridThemeParse,
    colorThemeParse,
    graphicParse,

    // series -------------------------------------------------------
    barThemeParse,
    progressBarThemeParse,
    lineThemeParse,
    pieThemeParse
  ]
} as Theme;
